__turbopack_context__.v({
  "backButton": "styles-module-scss-module__CSYtGW__backButton",
  "button": "styles-module-scss-module__CSYtGW__button",
  "footer": "styles-module-scss-module__CSYtGW__footer",
  "listItem": "styles-module-scss-module__CSYtGW__listItem",
  "root": "styles-module-scss-module__CSYtGW__root",
  "title": "styles-module-scss-module__CSYtGW__title",
  "titleText": "styles-module-scss-module__CSYtGW__titleText",
});
